import Contaier from "../../components/layout/Container/Container";
import Footer from "../../components/molecules/Footer/Footer";
import LoginHeader from "../../components/molecules/Header/LoginHeader";
import Banner from "../../components/layout/Sections/Banner";

function AccountSuccess() {   
      return (
    <>
      <LoginHeader />
      <Contaier>
        <Banner name="E-Services account acknowledgment page" uiClass="banner-bg" />
        <div className="inner-content">
          <div className="container">
            <div className="row">
            <div className="col-md-12">
    <h4>Congratulations!</h4>
    <p>The E-Services account has been successfully created. Please check your email for account details.</p>
</div>
<div className="col-md-12">
    <a className="primary-btn" href="/eservices/login">Go to Login</a>
</div>
            
            </div>
          </div>
        </div>
      </Contaier>
      <Footer />
    </>
  );
}

export default AccountSuccess;
